<template>
  <div class="show-correct" ref="activity_scroll" @scroll="activityScroll">
    <div class="middle-content">
        <i class="iconfont icon-sousuo"></i>
        <van-field
            v-model="searchValue"
            placeholder="输入产品名称"
            class="input"
            @input="searchValueChange"
        />
    </div>
    <!-- 视频 -->
    <newProVideo :productVideo="productVideo" @videoChange="videoChange"></newProVideo>
    <footerLine></footerLine>
    <!-- 视频播放 -->
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import newProVideo from './components/new-pro-video.vue'
import { getProBindList } from '@/api/centrifuge'
import DPlayer from 'dplayer'
import { debounce } from '@/libs/util'
import videoPlay from '@/components/videoPlay'
import footerLine from '@/components/footerLine'
export default {
    components: {
        newProVideo,
        videoPlay,
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            productVideo: [],
            showVideo: false,
            searchValue: ''
        }
    },
    created() {
        this.getProList()
    },
    methods: {
        getProList() {
            let para = {
                module: '4',
                type: '1',
                page: this.page,
                title: this.searchValue,
                cid: 0
            }
            getProBindList(para).then(res => {
                this.productVideo.push(... res.data.data)
                this.last_page = res.data.last_page
            })
        },
        searchValueChange: debounce(function (val) {
            this.productVideo = []
            this.getProList()
        }, 800),
        activityScroll () {
            // console.log('查看');
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
    }
}
</script>

<style lang="scss" scoped>
.show-correct {
    height: 100vh;
    overflow: auto;
    padding-top: rem(20);
}
.middle-content {
    height: rem(30);
    border-radius: 4px;
    display: flex;
    align-items: center;
    color: #9d9d9d;
    margin: 0 rem(20) rem(20) rem(20);
    padding: 0 rem(11);
    background: #f4f4f4;
    .iconfont {
        color: #9d9d9d;
    }
    .van-cell {
        padding-left: rem(8);
    }
    .input {
        background: none;
    }
}
</style>